import { getListQueryParamName } from 'src/_helpers/listQueryParams'

// Numer strony pod zlokalizowaną nazwą (`strona` / `page`), tak jak na pozostałych listach i w przełączniku języka.
export const buildCurrentStateUrl = (location, page, filters, order, locale) => {
  const pageParam = (locale && getListQueryParamName('page', locale)) || 'page'
  let url = `${location}?${pageParam}=${page}${order ? `&${order}` : ''}`

  const filterable = Object.keys(filters || {})

  if (filterable.length > 0) {
    url = `${url}&${filterable
      .map((filter) =>
        Array.isArray(filters[filter])
          ? filters[filter].map((value) => `${filter}[]=${encodeURIComponent(value)}`).join('&')
          : `${filter}=${encodeURIComponent(filters[filter])}`,
      )
      .join('&')}`
  }

  return url
}
